import React, { useState, lazy } from 'react';
import styles from '../styles/couplesLocationSharing.module.css';
import useMediaQuery from '../../../hooks/useMediaQuery';

const PhoneVerificationComponent = lazy(() => import('../../../components/sharedComponents/PhoneVerification'));


const CouplesLocationSharingHero = ({ showCheckoutPopup }) => {

    const isAboveMediumScreens = useMediaQuery("(min-width: 500px)");

    const [toggleSearchInput, setToggleSearchInput] = useState(true);

    const togglePhoneVerificationPopup = (e) => {
        e.preventDefault();
        setToggleSearchInput(!toggleSearchInput);
    }

    return (
        <section>
            <div className={styles.heroBgImage}>
                <div className={styles.homeHeroInnerContainer}>
                    <div className='maxScreen'>
                        {!isAboveMediumScreens && <div className={styles.emptyContainer}></div>}
                        <div className={styles.heroContainer}>
                            <h1 className={styles.heading}><span className="hightLightText">Stay Close,</span>
                                <br></br> With The World’s #1 Location Sharing App For Couples</h1>
                            <p className={styles.paragraph}>
                            Long-distance relationships, busy schedules, or just everyday life, Device Tracker Plus keeps you and your partner effortlessly connected.</p>
                            <br />
                            <br />
                            <div className='inputContainer'>
                                {toggleSearchInput && <PhoneVerificationComponent showPopUp={togglePhoneVerificationPopup} />}
                            </div>

                        </div>
                        <div className={styles.emptyContainer}></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CouplesLocationSharingHero;